import type { TrainableModelItem } from '../types/api';
import { isBaseModelUnsupportedForFineTuning } from './gpt5ConfiguratorModels';

/** OpenAI base models supported for fine-tuning in the UI (always offered in pickers). */
export const DEFAULT_FINE_TUNING_BASE_MODELS = [
  'gpt-4.1',
  'gpt-4.1-mini',
  'gpt-4.1-2025-04-14',
  'gpt-4.1-nano-2025-04-14',
] as const;

function isFineTuningBaseModelOption(modelId: string): boolean {
  const trimmed = modelId.trim();
  return Boolean(trimmed) && !isBaseModelUnsupportedForFineTuning(trimmed);
}

/** Unique FT-allowed base models: API list merged with defaults and optional fallback. */
export function listFineTuningBaseModelOptions(
  items: TrainableModelItem[],
  fallback: string[] = []
): string[] {
  const fromApi = items
    .map((item) => String(item.base_model || '').trim())
    .filter(isFineTuningBaseModelOption);
  const fromFallback = [...DEFAULT_FINE_TUNING_BASE_MODELS, ...fallback]
    .map((m) => String(m).trim())
    .filter(isFineTuningBaseModelOption);

  const merged = Array.from(new Set([...fromApi, ...fromFallback]));
  const knownSet = new Set<string>(DEFAULT_FINE_TUNING_BASE_MODELS);
  const known = DEFAULT_FINE_TUNING_BASE_MODELS.filter((model) => merged.includes(model));
  const extras = merged.filter((model) => !knownSet.has(model));
  return [...known, ...extras];
}
